import { render, staticRenderFns } from "./posted-jobs.vue?vue&type=template&id=2f17bedb&scoped=true"
import script from "./posted-jobs.vue?vue&type=script&lang=js"
export * from "./posted-jobs.vue?vue&type=script&lang=js"
import style0 from "./posted-jobs.vue?vue&type=style&index=0&id=2f17bedb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17bedb",
  null
  
)

export default component.exports